import MagnifierControl from './magnifier-control';
import us from '../../defines';
import app from '../../public-api';
import {env} from '../../lib/utility/browser-compatibility';

const loader = {
  name: 'us:magnifier',

  extends: 'viewport',

  dependencies: ['us:user-config'],

  canStart () {
    if (env.isIOS) {
      us.ENABLEMAG = false;
    }
    return us.ENABLEMAG;
  },

  constructor: MagnifierControl
};

app.plugins.register(loader);



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/magnifier/magnifier-loader.js